import { type FamilyRelativeRow, familyRelativeRecords } from '@liza/fhir-utils';
import { useTranslation } from 'react-i18next';
import { FamilyHistoryFactItem } from './FamilyHistoryFactItem';
import { FamilyHistoryGroupRow } from './FamilyHistoryGroupRow';
import type { FamilyHistoryItemProps } from './familyHistoryRows';
import { relativeLabel } from './familyMemberHistoryUtils';

export type FamilyHistoryUnattributedRowProps = FamilyHistoryItemProps & { row: FamilyRelativeRow };

/** History recorded against no particular relative, collapsed to one line with a condition count. */
export const FamilyHistoryUnattributedRow = ({
  row,
  ...itemProps
}: FamilyHistoryUnattributedRowProps): React.ReactElement => {
  const { t } = useTranslation('records');
  const title = relativeLabel(row.relative.slot, t);
  return (
    <FamilyHistoryGroupRow
      title={title}
      description={t('familyConditionsCount', { count: row.conditions.length })}
      ariaLabel={t('showFamilyMemberRecords', { name: title })}
      testId="family-history-unattributed"
      recordIds={familyRelativeRecords(row.relative).map((r) => r.id)}
      selectedId={itemProps.selectedFamilyMemberId}
    >
      {row.conditions.map((fact) => (
        <FamilyHistoryFactItem key={fact.condition.key} fact={fact} title={fact.condition.label} {...itemProps} />
      ))}
    </FamilyHistoryGroupRow>
  );
};
